<onyx-information-heading>
  {{ (trailer() ? 'labels.vehicles' : 'labels.vehicle') | translate }}

  @if (showEdit() && (!vehicle() || FleetHelper.isFleetType(vehicle()!))) {
    <onyx-icon-button
      actions
      variant="transparent"
      color="gray"
      [size]="32"
      icon="edit-outlined"
      [circle]="true"
      [disabled]="hasActiveDelegation()"
      [onyxTooltip]="
        hasActiveDelegation()
          ? 'labels.driverHasActiveDelegation'
          : 'labels.edit'
      "
      (click)="!hasActiveDelegation() ? edit.emit() : null"
    ></onyx-icon-button>
  }
</onyx-information-heading>

@if (vehicle(); as vehicle) {
  <div class="vehicles">
    <ng-container
      *ngTemplateOutlet="fleetItemTemplate; context: { fleet: vehicle }"
    ></ng-container>

    @if (trailer(); as trailer) {
      <ng-container
        *ngTemplateOutlet="fleetItemTemplate; context: { fleet: trailer }"
      ></ng-container>
    } @else if (telematicsStore.loading()) {
      <onyx-data-widget>
        <div class="center-section">
          <onyx-spinner color="black" [size]="24"></onyx-spinner>
        </div>
      </onyx-data-widget>
    } @else if (loadedSemiTrailer(); as loadedSemiTrailer) {
      @if (loadedSemiTrailer.registrationNumber; as registrationNumber) {
        <onyx-data-widget
          [headingIcon]="{
            name: 'semi-trailer-loaded-filled',
            size: 20,
            color: 'sea-green',
          }"
        >
          <div heading class="heading">
            <p>{{ registrationNumber }}</p>

            <onyx-icon
              name="tooltip-filled"
              [size]="20"
              [onyxTooltip]="`${I18N}.loadedOutsourcingSemiTrailerTooltip`"
            ></onyx-icon>
          </div>

          <p class="f-muted">
            {{
              `${DictionaryCode.VEHICLE_TYPE}.${loadedSemiTrailer.vehicleType}`
                | translate
            }}

            <span>·</span>

            {{
              `${DictionaryCode.ORDER_SEMI_TRAILER_SIZE}.${loadedSemiTrailer.minSemiTrailerSize}`
                | translate
            }}
          </p>
        </onyx-data-widget>
      } @else if (loadedSemiTrailer.type; as type) {
        <onyx-data-widget [padding]="16">
          <div class="planned-pickup">
            @let isOutsourcing = type === 'outsourcing';
            {{
              `${I18N}.${isOutsourcing ? 'plannedOutsourcingPickup' : 'plannedPickup'}`
                | translate
            }}

            <div class="content">
              <onyx-link
                color="black"
                (click)="openOrderModal(loadedSemiTrailer.orderUuid)"
              >
                {{ loadedSemiTrailer.orderIdentifier }}
              </onyx-link>

              <onyx-icon
                [class.outsourcing]="isOutsourcing"
                name="tooltip-filled"
                [size]="16"
                [onyxTooltip]="`${I18N}.${isOutsourcing ? 'loadedOutsourcingSemiTrailerTooltip' : 'loadedSemiTrailerTooltip'}`"
              ></onyx-icon>
            </div>
          </div>
        </onyx-data-widget>
      }
    } @else {
      <onyx-data-widget>
        <div class="center-section">
          {{
            `labels.${vehicle.generalInformation.category === FleetCategory.SEMI_TRUCK ? 'noSemiTrailer' : 'noTrailer'}`
              | translate
          }}
        </div>
      </onyx-data-widget>
    }
  </div>
} @else {
  <onyx-message intent="warning">
    <onyx-icon name="alert-circle-two-tone-filled" [size]="20"></onyx-icon>

    <p>{{ `${I18N}.noVehicle` | translate }}</p>

    <onyx-button variant="ghost" [size]="32" (click)="edit.emit()">
      {{ 'labels.assign' | translate }}
    </onyx-button>
  </onyx-message>
}

<ng-template let-fleet="fleet" #fleetItemTemplate>
  <onyx-data-widget
    [headingIcon]="{
      name: getFleetIcon(fleet.generalInformation.category),
      size: 20,
      color: 'black',
    }"
    [clickable]="true"
    (click)="openFleetModal(fleet)"
  >
    <p heading>{{ fleet | fleetIdentifier }}</p>

    <app-fleet-description-parameters
      description
      [fleet]="fleet"
      [isCell]="false"
    ></app-fleet-description-parameters>
  </onyx-data-widget>
</ng-template>
